import $ from 'jquery';

function init() {
    document.querySelectorAll('.js-virtual-tour').forEach(elem => elem.addEventListener("click", onVirtualTourButtonClick));

    document.addEventListener('click', function(e) {
        if (e.target && e.target.className && typeof e.target.className === 'string' && e.target.className.includes('virtualTour__close')) {
            onVirtualTourClose();
        }
    });
}

function onVirtualTourButtonClick(event) {
    const btn = event.target;

    if (!btn) return;

    const virtualTourLink = btn.dataset.virtualTourLink;
    const virtualTourCloseButtonText = btn.dataset.virtualTourCloseButtonText;
    const virtualTourAriaLabel = btn.dataset.virtualTourAriaLabel;

    generateiFrameMarkup({ virtualTourLink, virtualTourCloseButtonText, virtualTourAriaLabel });
}

function generateiFrameMarkup({ virtualTourLink, virtualTourCloseButtonText, virtualTourAriaLabel}) {
    $('body').append('<div class="virtualTour__modal"><button class="btn virtualTour__close" type="button" aria-label="'+virtualTourAriaLabel +'"><svg role="img"><use xlink:href="/Static/images/sprites/symbol.svg#close"></use></svg><span class="visually-hidden">' + virtualTourCloseButtonText + '</span></button><iframe class="virtualTour__iframe" src="' + virtualTourLink + '"  allowFullScreen="true" mozallowfullscreen="true" webkitAllowFullScreen="true"></iframe></div>');
}

function onVirtualTourClose() {
    const tourModal = document.querySelector('.virtualTour__modal');
    if (tourModal) {
        tourModal.remove();
    }
}

window.addEventListener('load', init);